import {
  IRegistration,
  ListRegistrationsExtensibleFields,
  RegistrationApplicabilityFilter,
} from '@commenda/types/src/registration/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export function useRegistrations(
  businessEntityId: number,
  extend?: ListRegistrationsExtensibleFields[],
  applicability?: RegistrationApplicabilityFilter
) {
  const queryString = new URLSearchParams();

  if (extend) queryString.append('extends', extend.join(','));
  if (applicability) queryString.append('applicability', applicability);

  const {
    data,
    error,
    mutate,
  }: {
    data?: { registrations: IRegistration[]; count: number };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    `business-entities/${businessEntityId}/registrations${queryString.toString() ? `?${queryString.toString()}` : ''}`,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    mutate,
  };
}
